import StateManager from './StateManager';
import $ from 'jquery';
import _ from 'underscore';

/* -------------------------
    INIT
------------------------- */

$(window).on(StateManager.CONTENT_READY, function(event, node) {
    $(node).find('.js-scuba__list').each(function(i, list) {
        new Scuba_List(list);
    });
});





/* --------------------------------------------------

    (CLASS) LIST

-------------------------------------------------- */

var Scuba_List = function() {
    // console.log('new Scuba_List()');
    this.initialize.apply(this, arguments);
};

$.extend(Scuba_List.prototype, {

    initialize: function(list) {
        this.uid = _.uniqueId('scuba-');
        this.$list = $(list).data('js-scuba__list', this);
        this.$page = this.$list.closest('.js-scuba__page, .js-scuba__head');
        this.$section = this.$list.closest('.js-scuba__section').addClass('full-height');
        this.$page.on('scuba:dispose', $.proxy(this.dispose, this));
        this.$sectionContent = this.$list.closest('.js-scuba__content');

        this._invalidate = this.invalidate;
        this.invalidate = _.debounce(this._invalidate, 100);

        // récupération des paramètres partagés
        this.params = this.$list.data('scuba-list-params');
        if (!this.params) {
            this.$list.data('scuba-list-params', this.params = {});
        }

        this.$itemsContainer = this.$list.find('.js-scuba__list__items');
        this.$viewport = this.$sectionContent.length ? this.$sectionContent : this.$itemsContainer;
        this.$viewport.on('click', '.js-scuba__list__load-more a', $.proxy(this.more_clickHandler, this));

        this.$items = this.$viewport.find('.js-scuba__list__item');
        this.$visibleItems = this.$items.first();
        this.params.totalItems = parseInt(this.$viewport.data('total-items')) || this.$items.length;

        this.$prevButton = this.$list.find('.js-scuba__list__navbar__prev');
        this.$nextButton = this.$list.find('.js-scuba__list__navbar__next');

        this.$count = this.$list.find('.js-scuba__list__count');
        this.countDefault = this.$count.html();
        this.$prevCount = this.$list.find('.js-scuba__list__navbar__prev__count');
        this.$nextCount = this.$list.find('.js-scuba__list__navbar__next__count');

        this.$progress = this.$list.find('.js-scuba__list__navbar__progress');
        this.$progressThumb = this.$progress.find('.js-scuba__list__navbar__progress__thumb');

        this.preventInvalidate = false;

        // écouteurs

        this.$prevButton.on('click', $.proxy(this.$prevButton_clickHandler, this));
        this.$nextButton.on('click', $.proxy(this.$nextButton_clickHandler, this));

        this.$list.on('visibleRangeChanged', $.proxy(this.visibleRangeChangedHandler, this));
        this.$list.on('totalItemsChanged', $.proxy(this.totalItemsChangedHandler, this));
        this.$list.on('itemsChanged', $.proxy(this.itemsChangedHandler, this));

        this.$viewport.on('scroll', $.proxy(this.invalidate, this));
        this.$viewport.on('scroll', $.proxy(this.checkMorePosition, this));
        this.$viewport.on('scroll', $.proxy(this.checkGlobalPosition, this));
        $(window).on('resize.'+this.uid, $.proxy(this.invalidate, this));

        // init
        var layout = $(document.body).on('layout:change.'+this.uid, $.proxy(this.invalidateLayout, this)).data('layout');
        this.invalidateLayout(null, layout);

        this.totalItemsChangedHandler();

        setTimeout($.proxy(this.invalidate, this), 20);

        // indique que le controller est prêt
        this.$list.trigger('scuba-list', this);
    },

    dispose: function() {
        // console.log('Scuba_List.dispose()');
        $(window).off('.'+this.uid);
        $(document.body).off('.'+this.uid);
    },

    /* --------------------------------------------------
        LISTENERS
    -------------------------------------------------- */

    invalidateLayout: function(event, layout) {
        this.isHorizontal = layout === 'HorizontalLayout';

        if ((this.isHorizontal || !this.isHorizontal) && (typeof this.$list.attr("data-click-scroll-helper") !== "undefined") ) {
            this.$viewport.addClass('items-visibility-on');
            this.$viewport.on('click', '.js-scuba__list__item:not(.is-visible)', $.proxy(this.outboundsItem_clickHandler, this));
            this.invalidate();
        } else {
            this.$viewport.removeClass('items-visibility-on');
            this.$viewport.off('click', '.js-scuba__list__item:not(.is-visible)', $.proxy(this.outboundsItem_clickHandler, this));
        }
    },

    visibleRangeChangedHandler: function(/*event*/) {
        var total = this.params.totalItems;
        var first = this.params.firstVisibleIndex;
        var last = this.params.lastVisibleIndex;

        if (this.$progressThumb.length) {
            this.$progressThumb.css({
                left : Math.min(first / (total-1) * 100, 95) + '%',
                width : Math.max((last - first) / (total-1) * 100, 5) + '%',
            });
        }

        if (this.$prevCount.length) {
            this.$prevCount.text(first > 0 ? '1 - '+ (first+1) : '');
        }

        if (this.$nextCount.length) {
            this.$nextCount.text(last+1 < total ? (last+1) + ' - ' + total : '');
        }
    },

    outboundsItem_clickHandler: function(event) {
        event.preventDefault();
        event.stopPropagation();

        // détermine si l'item est en bas ou en haut de la liste
        var item = event.currentTarget;
        var $item = $(item);

        var viewportTop = this.$viewport.offset().top;
        var viewportHeight = this.$viewport.outerHeight();
        var itemTop = $item.offset().top;
        if (itemTop < viewportTop + viewportHeight / 2) {
            this.gotoPrevPage();
        } else {
            this.gotoNextPage();
        }
    },

    totalItemsChangedHandler: function(/*event*/) {
        // console.log('ListSnap.totalItemsChangedHandler()');
        var total = this.params.totalItems;
        // var first = this.params.firstVisibleIndex;
        var last = this.params.lastVisibleIndex;

        if (this.$count.length) {
            this.$count.html(this.countDefault.replace("#", total));
            this.$count.removeClass (function (index, css) {
                return (css.match (/(^|\s)count--\S+/g) || []).join(' ');
            }).addClass("count--"+total);
        }

        if (this.$nextCount.length) {
            this.$nextCount.text(last+1 < total ? (last+1) + ' - ' + total : '');
        }

        this.checkGlobalPosition();
    },

    itemsChangedHandler: function(/*event*/) {
        this.$items = this.$viewport.find('.js-scuba__list__item');
        this.$more = this.$items.filter('.js-scuba__list__load-more').first();
        if (!this.$more.length) this.$more = null;
        this.invalidate();
        this.checkMorePosition();
    },

    $prevButton_clickHandler: function(event) {
        event.preventDefault();
        event.stopPropagation();
        this.gotoPrevPage();
    },

    $nextButton_clickHandler: function(event) {
        event.preventDefault();
        event.stopPropagation();
        this.gotoNextPage();
    },

    /* --------------------------------------------------
        CHECK IF SCROLLED TO TOP OR BOTTOM
    -------------------------------------------------- */

    checkGlobalPosition: function() {
      var wrapScroll = this.$viewport.scrollTop();
      var scrollerHeight = this.$viewport.get(0).scrollHeight;
      var wrapHeight = this.$viewport.outerHeight();

      if(wrapScroll > 0){
        this.$list.removeClass("has-scrolled-to-top");
      } else {
        this.$list.addClass("has-scrolled-to-top");
      }

      if(wrapScroll < (scrollerHeight - wrapHeight)){
        this.$list.removeClass("has-scrolled-to-bottom");
      } else {
        this.$list.addClass("has-scrolled-to-bottom");
      }
    },

    /* --------------------------------------------------
        MORE
    -------------------------------------------------- */

    checkMorePosition: function() {
        if (!this.$more) return;

        var moreTop = this.$more.offset().top;
        var wrapTop = this.$viewport.offset().top;
        var wrapHeight = this.$viewport.outerHeight();
        // var wrapScroll = this.$viewport.scrollTop();
        if (moreTop < wrapTop + wrapHeight + wrapHeight /** 0.5*/) {
            this.more_clickHandler();
        }
    },

    more_clickHandler: function(event) {
        // console.log('more_clickHandler');
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        var $moreLink = this.$more.find('a');

        if ($moreLink.is('.is-loading')) return;
        $moreLink.addClass('is-loading');

        this.more_jqXHR = $.ajax({
            type: 'get',
            url: $moreLink.attr('href'),
            dataType: 'json',
            context: this,
        });

        this.more_jqXHR.$more = this.$more;
        this.more_jqXHR.done(this.more_jqXHR_doneHandler);
        this.more_jqXHR.fail(this.more_jqXHR_failHandler);
        this.more_jqXHR.always(this.more_jqXHR_alwaysHandler);
    },

    more_jqXHR_doneHandler: function(data, textStatus, jqXHR) {
        data = this.parseItems(data.html);
        if (data) {
            jqXHR.$more.closest('.js-scuba__list__item').replaceWith(data.$items);
            this.$list.trigger('itemsChanged');
        }
    },

    more_jqXHR_failHandler: function(/*jqXHR, textStatus, errorThrown*/) {
        // console.log('tutu');
        this.$more.removeClass('is-loading');
    },

    more_jqXHR_alwaysHandler: function(/*jqXHR, textStatus, errorThrown*/) {
        this.more_jqXHR = null;
    },



    /* --------------------------------------------------
        METHODS
    -------------------------------------------------- */

    /**
     * Attribue de nouvelles données à la liste.
     */
    setItems: function($items, total) {
        /*if (!$items || !$items.length) return;  // A supprimer après validation - félix */
        if (!$items) return;
        if (!total) total = $items.length;

        this.params.totalItems = total;
        this.$list.trigger('totalItemsChanged');

        this.$itemsContainer.children(":not(.js-scuba__list__item--fixed)").remove();

        this.$itemsContainer.append($items)
            .trigger('itemsChanged')
            .scrollTop(0);
    },

    /**
     * Cherche le premier groupe d'items dans la chaine et remplace
     * le contenu actuel de la liste par les nouveaux items.
     */
    parseItems: function(str, add) {
        var rgx = /<!--\[scuba-list-items\((\d+)\)-->[\s\n\r]*([\w\W]*?)[\s\n\r]*<!--scuba-list-items\]-->/i;
        var matches = str.match(rgx);
        if (!matches) return null;

        var $items = $(matches[2]).filter('.js-scuba__list__item');
        var total = parseInt(matches[1]) || 0;

        if (add) this.setItems($items, total);

        return {
            $items: $items,
            total: total,
        };
    },

    /* --------------------------------------------------
        METHODS
    -------------------------------------------------- */

    gotoPrevPage: function() {
        var $item = this.$visibleItems.first();
        if (!$item.length) return;

        var $prev = $item.prev();

        $item = $prev.length ? $prev : $item;

        var itemY = $item.offset().top;
        var itemHeight = $item.outerHeight();

        var viewportY = this.$viewport.offset().top;
        var viewportScrollTop = this.$viewport.scrollTop();
        var viewportHeight = this.$viewport.height();

        this.scrollTo(itemY - viewportY + viewportScrollTop - viewportHeight + itemHeight);
    },

    gotoNextPage: function() {
        var $item = this.$visibleItems.last();
        if (!$item.length) return;

        var $next = $item.next('.js-scuba__list__item');

        $item = $next.length ? $next : $item;

        var itemY = $item.offset().top;

        var viewportY = this.$viewport.offset().top;
        var viewportScrollTop = this.$viewport.scrollTop();

        this.scrollTo(itemY - viewportY + viewportScrollTop);
    },

    scrollTo: function(scrollTop) {
        var scrollTopMax = this.$viewport.get(0).scrollHeight - this.$viewport.height();
        scrollTop = Math.min(Math.max(0, scrollTop), scrollTopMax);

        this.preventInvalidate = true;

        this.$viewport.stop(true).animate(
            { scrollTop: scrollTop },
            400,
            'swing',
            $.proxy(function() {
                this.preventInvalidate = false;
                this.invalidate();
            }, this)
        );
    },

    invalidate: function() {
        if (this.preventInvalidate) return;

        var $viewport = this.$viewport;

        // récupère le 1er item visible
        var $item = this.$visibleItems.eq(0);

        // s'il n'y en a pas ou qu'il ne fait plus parti de la liste
        if (!$item.length || $.inArray($item.get(0), this.$items) < 0) {
            // récupère le premier item
            $item = this.$items.first();
        }

        var $visibleItems = $([]);

        // s'il n'y en a toujours pas... on arrête ici
        if (!$item.length) {
            this.$visibleItems = $visibleItems;
            return;
        }

        // coordonnées viewport
        var minY = $viewport.offset().top;
        var maxY = minY + this.$viewport.height();

        // ajoute des marges de sécurité
        minY-=2;
        maxY+=2;

        // coordonnées du 1er item visible
        var itemMinY = $item.offset().top;
        // var itemMaxY = itemMinY + $item.outerHeight();
        // var itemVisible = itemMinY >= minY && itemMaxY <= maxY;

        // utilisés durant les boucles
        var searching, $i;

        // cherche le 1er item visible vers le haut
        if (minY <= itemMinY) {
            searching = true;
            while (searching) {
                $i = $item.prev('.js-scuba__list__item');
                if ($i.length && minY <= $i.offset().top) {
                    $item = $i;
                } else {
                    searching = false;
                }
            }
        }
        // cherche le 1er item visible vers le bas
        else if (minY > itemMinY) {
            searching = true;
            while (searching) {
                $i = $item.next('.js-scuba__list__item');
                if ($i.length) {
                    $item = $i;
                    if (minY <= $i.offset().top) {
                        searching = false;
                    }
                } else {
                    searching = false;
                }
            }
        }

        $visibleItems = $item;

        // récupère tous les items visibles
        searching = true;
        while (searching) {
            $i = $item.next('.js-scuba__list__item');
            if ($i.length && maxY >= $i.offset().top + $i.outerHeight()) {
                $item = $i;
                $visibleItems = $visibleItems.add($i);
            } else {
                searching = false;
            }
        }

        // modifications des classes et enregistrement
        this.$visibleItems.removeClass('is-visible');
        this.$visibleItems = $visibleItems;
        this.$visibleItems.addClass('is-visible');

        this.params.firstVisibleIndex = $.inArray(this.$visibleItems.get(0), this.$items);
        this.params.lastVisibleIndex = $.inArray(this.$visibleItems.last().get(0), this.$items);

        this.$list.trigger('visibleRangeChanged');
    },

});

export default Scuba_List;


// WEBPACK FOOTER //
// ./scripts/scuba/ListSnap.js